export default {
  namespaced: true,
  state: {
    feedbackRatingOptions: []
  },
  mutations: {
    setFeedbackRatingOptions(state, payload) {
      state.feedbackRatingOptions = payload;
    }
  }
};
